var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useContext, useState } from "react";
import { ETaskExecutionStatus } from "@sequentech/ui-core";
import { WidgetsStack } from "@/components/WidgetsStack";
var WidgetContext = createContext({
    addWidget: function () { return ({}); },
    setWidgetTaskId: function () { },
    updateWidgetFail: function () { },
});
export var WidgetsContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState(new Map()), widgetsState = _b[0], setWidgetsState = _b[1];
    var generateWidgetId = function () {
        var now = new Date();
        var formattedDate = now.toISOString().replace(/[-:.TZ]/g, "");
        return "widget_".concat(formattedDate);
    };
    var addWidget = function (type, automaticallyDownload) {
        if (automaticallyDownload === void 0) { automaticallyDownload = false; }
        var newWidget = {
            type: type,
            status: ETaskExecutionStatus.IN_PROGRESS,
            onClose: onClose,
            identifier: generateWidgetId(),
            automaticallyDownload: automaticallyDownload,
        };
        setWidgetsState(function (prevState) { return new Map(prevState.set(newWidget.identifier, newWidget)); });
        return newWidget;
    };
    var setWidgetTaskId = function (widgetIdentifier, taskId, onSuccess) {
        setWidgetsState(function (prevState) {
            var widget = prevState.get(widgetIdentifier);
            if (widget) {
                widget.taskId = taskId;
                widget.onSuccess = onSuccess;
                prevState.set(widgetIdentifier, __assign({}, widget));
            }
            return new Map(prevState);
        });
    };
    var updateWidgetFail = function (widgetIdentifier) {
        setWidgetsState(function (prevState) {
            var widget = prevState.get(widgetIdentifier);
            if (widget) {
                widget.status = ETaskExecutionStatus.FAILED;
                prevState.set(widgetIdentifier, widget);
            }
            return new Map(prevState);
        });
    };
    var onClose = function (widgetIdentifier) {
        setWidgetsState(function (prevState) {
            prevState.delete(widgetIdentifier);
            return new Map(prevState);
        });
    };
    return (_jsxs(WidgetContext.Provider, __assign({ value: { addWidget: addWidget, setWidgetTaskId: setWidgetTaskId, updateWidgetFail: updateWidgetFail } }, { children: [children, widgetsState.size > 0 && _jsx(WidgetsStack, { widgetsMap: widgetsState })] })));
};
export var useWidgetStore = function () {
    var _a = useContext(WidgetContext), addWidget = _a.addWidget, setWidgetTaskId = _a.setWidgetTaskId, updateWidgetFail = _a.updateWidgetFail;
    return [addWidget, setWidgetTaskId, updateWidgetFail];
};
